import type { AppAction } from '../actions';
import type { WebSocketStatus } from '@thinkalpha/common/push/socket.js';
import type { UploadableLocateProvider } from '@thinkalpha/ui-types/contracts/locates/inventory';
import type { LocateOrder } from '@thinkalpha/ui-types/contracts/locates/orders';
import type { LocateAccount } from '@thinkalpha/ui-types/contracts/locates/platforms';
import type { LocateProvider } from '@thinkalpha/ui-types/contracts/locates/providers';
import type { LocatePreferences, SoundAlert } from 'src/store/types/locates';

export interface StoredLocateOrder extends LocateOrder {
    isRemoved?: boolean; // if the order should be removed then it will not be shown in the orders table
}

export interface LocatesState {
    isLocatesBootstrapComplete: boolean;
    providers: LocateProvider[];
    uploadableProviders: UploadableLocateProvider[];
    accounts: LocateAccount[];
    locatePreferences: LocatePreferences | null;
    status: WebSocketStatus | 'uninitialized';
    orders: StoredLocateOrder[];
    enabledSoundAlerts: SoundAlert[];
}

const initialState: LocatesState = {
    isLocatesBootstrapComplete: false,
    providers: [],
    uploadableProviders: [],
    accounts: [],
    locatePreferences: null,
    status: 'uninitialized',
    orders: [],
    enabledSoundAlerts: [],
};

export const locates = (state = initialState, action: AppAction): LocatesState => {
    switch (action.type) {
        case 'locates::setProviders':
            return {
                ...state,
                providers: action.providers,
            };
        case 'locates::setUploadableProviders':
            return {
                ...state,
                uploadableProviders: action.uploadableProviders,
            };
        case 'locates::setLocatePreferences':
            return {
                ...state,
                locatePreferences: action.locatePreferences,
            };
        case 'locates::setBootstrapComplete':
            return {
                ...state,
                isLocatesBootstrapComplete: action.isLocatesBootstrapComplete,
            };
        case 'masq::access-token::set': {
            return { ...initialState };
        }
        case 'locates::setAccounts':
            return {
                ...state,
                accounts: action.accounts,
            };
        case 'locates::setStatus':
            return {
                ...state,
                status: action.status,
            };
        case 'locates::setOrders':
            return {
                ...state,
                orders: action.orders,
            };
        case 'locates::setEnabledSoundAlerts':
            return {
                ...state,
                enabledSoundAlerts: action.enabledSoundAlerts,
            };
        case 'locates::reset':
            return initialState;
    }
    return state;
};
